import { Field, useFormState, useForm } from 'react-final-form'
import dot from 'dot-object'
import Radio from '@mui/material/Radio'

import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBox from '@mui/icons-material/CheckBox'

type RadioFieldProps = {
  name: string
  id: string
  value: any
  style?: any
  overrideMuiStyle?: any
  onClick?: () => void
}

const RadioField = ({
  name,
  value,
  style,
  id,
  overrideMuiStyle,
  onClick,
}: RadioFieldProps) => {
  const form = useForm()
  const { values } = useFormState()

  return (
    <Field id={id} name={name} component="input" type="radio" value={value}>
      {({ input: { value, name, onChange, checked } }) => (
        <Radio
          id={id}
          style={style}
          checked={dot.pick(name, values) === value.toString()}
          disableRipple
          name={name}
          color="primary"
          value={value}
          onChange={onChange}
          checkedIcon={<CheckBox />}
          icon={<CheckBoxOutlineBlank color="primary" />}
          onClick={() => {
            if (checked) {
              form.change(name, '')
            }

            if (onClick) onClick!()
          }}
          sx={{
            '&.MuiRadio-root': {
              paddingTop: 0,
              '&:hover': {
                backgroundColor: 'transparent',
              },
            },
            ...overrideMuiStyle,
          }}
        />
      )}
    </Field>
  )
}

export default RadioField
